import React, { useEffect, useState } from 'react'
import { Text, View, TextInput, TouchableOpacity } from 'react-native'
import { FormFieldsModel, ModelAnswerFromProps } from '../models/StoreDetailModel'
import styles from './InputNumberPriceFieldStyles'
import { schedulesServices } from '../../../../database/schedules.database'
import { updateFormAnswerSchedule } from '../../../../db-sqlite/repositories/schedule.repository'
import theme from '../../../../theme'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import { useValidationAlerts, ValidationParentContext } from './useValidationAlerts'

interface InputNumberPriceFieldProps {
    item: FormFieldsModel
    form_id: string
    schedule_id: string
    store_id: string
    answerProp: ModelAnswerFromProps
    closeBottomSheet: (l) => void
    checkComplete: (option?: ModelAnswerFromProps) => void
    keyboardHiddenState: boolean
    onFocus: (id: string) => void
    activeInputId: string
    isPrice: boolean
    onSubInputMeasure?: (id: string, screenY: number, inputH: number) => void
    disabled?: boolean
    initialValue?: string
    computedValue?: string
    parentContext?: ValidationParentContext
}

export const InputNumberPriceField = ({
    item,
    form_id,
    schedule_id,
    store_id,
    answerProp,
    closeBottomSheet,
    checkComplete,
    keyboardHiddenState,
    onFocus,
    activeInputId,
    isPrice,
    onSubInputMeasure,
    disabled,
    initialValue,
    computedValue,
    parentContext,
}: InputNumberPriceFieldProps) => {
    //console.log('🚀 ~ answerProp:', answerProp)
    // console.log('🚀 ~ item:', item)
    const { languageFile } = getLanguage()
    const { checkAlerts } = useValidationAlerts()

    const [text, setText] = useState('')
    //console.log('🚀 ~ text:', text)
    const inputRef = React.useRef<TextInput>(null)

    useEffect(() => {
        // computedValue (fields con ponderate_config role "result") manda siempre:
        // ese efecto de más abajo es el que mantiene el texto sincronizado.
        if (computedValue !== undefined) return
        // initialValue viene de la respuesta ya persistida de ESTE field puntual
        // (buscada por su _id sintético en FieldsView), no del answerProp compartido
        // entre siblings, que sólo tiene lugar para un field_text.
        if (initialValue && initialValue !== '') {
            setText(initialValue)
        }
    }, [item._id, initialValue])

    useEffect(() => {
        if (computedValue === undefined) return
        setText(computedValue ?? '')
    }, [computedValue])

    useEffect(() => {
        if (disabled) return
        if (keyboardHiddenState && activeInputId == item._id) {
            if (text !== '') {
                validateAnswer(text)
            }
        }
    }, [keyboardHiddenState])

    const validateAnswer = async (text) => {
        if (disabled) return
        if (text.trim() === '') return

        const action = await checkAlerts(item, text, parentContext)
        if (action === 'reset') {
            setText('')
            return
        }
        create_answer(text)
    }
    const create_answer = (inputText: string) => {
        const answer: ModelAnswerFromProps = {
            _id: item._id,
            option_selected_text: answerProp.option_selected_text,
            option_selected_id: answerProp.option_selected_id,
            question_id: answerProp.question_id,
            media: '',
            question_text: answerProp.question_text,
            // score: answerProp.score ? answerProp.score.toString() : '0',
            score: item?.score ? item?.score.toString() : '0', // score del field
            status: 1,
            date_finish: new Date().toString(),
            date_init: new Date().toString(),
            question_input: '',
            field_media: '',
            field_text: inputText,
            // questionScore: answerProp.questionScore,
            questionScore: item?.questionScore ?? 0,
            index: answerProp.index,
            type: answerProp.type,
            ponderar: !!(item?.questionScore && item.questionScore > 0),

            question: item?.label || item?.title || '',
            questionOptionSelected: answerProp?.option_selected_id,
            questionOptionSelectedText: answerProp?.option_selected_text,
            questionType: (item as any).type,
            questionPrice: inputText,
            tag: '',
            questionImage: '',
            questionInput: inputText,

            sku: answerProp.sku,
            description: answerProp.description ?? '',
            description_short: answerProp.description_short ?? '',
        }

        updateFormAnswerSchedule({
            newAnswer: answer,
            schedule_id,
            form_id,
            store_id,
        })
        checkComplete(answer)
    }

    return (
        <View style={styles.container}>
            <View style={styles.containerInput}>
                {item.label && <Text style={styles.label}>{item.label}</Text>}
                <View style={styles.containerInputPrice}>
                    {isPrice === true && <Text style={styles.text}>$</Text>}
                    <TextInput
                        ref={inputRef}
                        style={[
                            styles.inputPrice,
                            disabled && styles.inputPriceDisabled,
                        ]}
                        //autoFocus={false}
                        placeholder='----'
                        placeholderTextColor={theme.colors.inputPlaceholder}
                        value={text}
                        editable={!disabled}
                        onChangeText={(text) => {
                            if (disabled) return
                            setText(text)
                        }}
                        keyboardType='number-pad'
                        inputMode='decimal'
                        onEndEditing={(e) => validateAnswer(e.nativeEvent.text)}
                        onSubmitEditing={(e) => validateAnswer(e.nativeEvent.text)}
                        onFocus={() => {
                            if (disabled) return
                            onFocus(item._id)
                            if (onSubInputMeasure) {
                                inputRef.current?.measureInWindow((x, y, w, h) => {
                                    onSubInputMeasure(item._id, y, h)
                                })
                            }
                        }}
                        autoFocus={!disabled && activeInputId === item._id}
                    />
                </View>
            </View>

            {/* <View style={styles.buttonContainer}>
                <TouchableOpacity style={styles.borderButton} onPress={validateAnswer}>
                    <Text style={styles.borderButtonText}>{languageFile.confirm}</Text>
                </TouchableOpacity>
            </View> */}
        </View>
    )
}
